import React from "react";
import MainView from "lib/components/MainView";
import logError from "lib/utils/errors/logError";
import { formatTime } from "lib/utils/socialtravel";

const RenderFallback = ({ error, errorId, retry, close }) => (
  <MainView.Dimmer
    failed
    errorTitle={`Błąd aplikacji`}
    errorDate={formatTime(moment())}
    errorId={errorId}
    retry={retry || close}
  />
);

// See https://github.com/facebook/react/issues/2461
export default function createErrorBoundary({ fallbackComponent = RenderFallback, onError } = {}) {
  return (Component) => {
    if (__DEV__) {
      return Component;
    }

    return class ErrorBoundary extends React.PureComponent {
      constructor(...args) {
        super(...args);
        this.state = { error: false };
      }

      unstable_handleError(e) {
        const errorId = logError(e);
        this.setState({ error: true, errorId });
      }

      render() {
        const Comp = this.state.error ? fallbackComponent : Component;
        return <Comp {...this.state} {...this.props} />;
      }
    };
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/errorBoundary.js